
<template>
  <div class="outPondReport">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">出塘报表</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>日期</span>
            <el-date-picker
              size="small"
              :clearable="false"
              v-model="order.startDate"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              @change="changeTime(0)"
              :picker-options="pickerTimeOptions"
            ></el-date-picker>
          </div>
          <div class="select-container-box" style="padding:0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding:0 1px">
            <el-date-picker
              size="small"
              :clearable="false"
              v-model="order.endDate"
              type="date"
              placeholder="结束日期"
              @change="changeTime(1)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions"
            ></el-date-picker>
          </div>
          <div class="select-container-box">
            <span>基地</span>
            <el-select
              filterable
              placeholder="请选择"
              size="small"
              v-model="order.baseId"
              @change="baseChange"
            >
              <el-option
                v-for="(item, index) in baseList"
                :key="index"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="pondList.length>0">
            <span>塘口</span>
            <el-select
              filterable
              @change="pondChange"
              placeholder="请选择"
              size="small"
              v-model="order.pondId"
            >
              <el-option
                v-for="(item, index) in pondList"
                :key="index"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>品种</span>
            <el-select filterable placeholder="请选择" size="small" v-model="order.fishId" style>
              <el-option
                v-for="(item, index) in fishList"
                :key="index"
                :label="item.categoryName"
                :value="item.categoryId"
              ></el-option>
            </el-select>
          </div>
          <div class="select-container-box total">
            <span>汇总方式</span>
            <el-select v-model="groupBy" multiple size="middle" placeholder="请选择" @change="setCache">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small" type="info" plain class="query" @click="search(1)">查询</el-button>
            <!-- <el-button size="small"  type="info" plain  class="add" >导出</el-button> -->
          </div>
        </div>
      </div>
      <div class="table-container">
        <!-- 表头 -->
        <table class="table-package" :class="isTop ? 'fix' : ''">
          <thead class="table-thead">
            <tr>
              <th v-if="showCol(2)">塘口</th>
              <th v-if="showCol(1)">品种</th>
              <th>出塘数量</th>
              <th>出塘重量</th>
              <th>出塘规格</th>
              <th>出塘均价</th>
              <th>出塘金额(元)</th>
            </tr>
          </thead>
        </table>
        <!-- 表体 -->
        <div class="scroll-box2" ref="scrollBox">
          <table class="table-package">
            <tbody class="table-tbodys" v-if=" this.order.details.length !== 0">
              <tr v-for="(item,index) in order.details" :key="index">
                <td
                  v-if="showCol(2)"
                  :rowspan="item.pondIdspan"
                  :class="{hidden: item.pondIddis}"
                >{{item.pondName}}</td>
                <td v-if="showCol(1)">{{item.fishName}}</td>
                <td>{{item.saleQuantity|decimal}}</td>
                <td>{{item.saleWeight|decimal}}</td>
                <td>{{item.saleSpec|decimal}}</td>
                <td>{{item.salePrice|decimal}}</td>
                <td>{{item.saleAmount|decimal}}</td>
              </tr>
            </tbody>
            <tbody class="table-tbodys" v-if=" this.order.details.length === 0">
              <tr>
                <td colspan="7">该时间段暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 表尾 -->
        <table class="table-package">
          <tfoot class="table-tfoot" v-if=" this.order.details.length !== 0">
            <tr class="row">
              <td v-if="showCol(2)">合计</td>
              <td v-if="showCol(1)">{{!showCol(2)?"合计":"--"}}</td>
              <td>{{total('saleQuantity')|decimal}}</td>
              <td>{{total('saleWeight')|decimal}}</td>
              <td>{{(total('saleSpec')/this.order.details.length)|decimal}}</td>
              <td>{{(total('salePrice')/this.order.details.length)|decimal}}</td>
              <td>{{total('saleAmount')|decimal}}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../service/storage";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";

export default {
  mixins: [mixins],
  name: "outPondReport",
  data() {
    return {
      options: [
        {
          value: "1",
          label: "品种"
        },
        {
          value: "2",
          label: "塘口"
        }
      ],
      // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      order: {
        groupBy: 3, //汇总方式--默认全选
        baseId: "", //基地
        pondId: "", //塘口
        startDate: "", //开始时间
        endDate: "", //结束时间
        remark: "",
        details: [],
        fishId: ""
      },
      groupBy: ["2"], //汇总方式
      baseList: [],
      pondList: [],
      fishList: [],
      isTop: false,
      fixWidth: 0
    };
  },
  async mounted() {
    // 监听滚动
    window.addEventListener("scroll", this.getScroll, true);
    // 设置表头宽度
    this.fixWidth = this.$refs.scrollBox.offsetWidth - 5;
    window.onresize = () => {
      return (() => {
        this.fixWidth = this.$refs.scrollBox.offsetWidth;
      })();
    };

    this.baseList = await this.getAllBaseList({ forQueryAll: true });
    this.order.baseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    await this.baseChange(this.order.baseId);
    this.getCache();
    this.search();
  },
  methods: {
    //监听滚动
    getScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 180) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.report, {
      GetOutPondReport: "GetOutPondReport"
    }),
    ...mapActions(modules.fish, {
      getFishReport: "getFishReport" //品种
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond"
    }),
    //动态合并表格
    combine(list, field, assistFields = []) {
      var k = 0;
      while (k < list.length) {
        list[k][field + "span"] = 1;
        list[k][field + "dis"] = false;
        for (var i = k + 1; i <= list.length - 1; i++) {
          let isEqual =
            list[k][field] == list[i][field] && list[k][field] != "";

          assistFields.forEach(item => {
            isEqual =
              isEqual && list[k][item] == list[i][item] && list[k][item] != "";
          });

          if (isEqual) {
            list[k][field + "span"]++;
            list[k][field + "dis"] = false;
            list[i][field + "span"] = 1;
            list[i][field + "dis"] = true;
          } else {
            break;
          }
        }
        k = i;
      }
      return list;
    },
    //汇总方式必须选一个
    showCol(value) {
      return (this.order.groupBy & value) > 0;
    },
    //总计
    total(prop) {
      let total = 0;
      this.order.details.forEach(item => (total += Number(item[prop])));
      return total;
    },
    //改变基地数据
    async baseChange(e) {
      storage.set("base", e);
      this.pondList = [];
      let result = [];
      if (!e) {
        result = [];
      } else {
        result = await this.getFishPond(e);
      }
      this.pondList = [
        {
          key: "",
          value: "全部"
        }
      ].concat(result);
      if (this.pondList.length === 0) {
        this.$Alert.info({
          content: "当前选择的基地下面无塘口，请先添加",
          duration: 5000,
          status: "error"
        });
        // Message.error("当前选择的基地下面无塘口，请先添加");
      }
      this.order.pondId = "";
      this.getFish();
      this.order.fishId = "";
    },
    //改变塘口数据
    async pondChange(e) {
      this.getFish();
      this.order.fishId = "";
    },
    //品种
    getFish() {
      let obj = {
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
        pondId: this.order.pondId
      };
      this.getFishReport(obj).then(rsp => {
        this.fishList = [
          {
            categoryId: "",
            categoryName: "全部"
          }
        ].concat(rsp);
      });
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.order.startDate);
      } else {
        storage.set("end", this.order.endDate);
      }
    },
    //查询
    async search() {
      let obj = {
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
        startDate: this.order.startDate,
        endDate: this.order.endDate,
        fishId: this.order.fishId,
        pondId: this.order.pondId,
        groupBy: this.groupBy.reduce((now, next) => Number(now) + Number(next))
      };
      try {
        this.order.details = this.combine(
          await this.GetOutPondReport(obj),
          "pondId"
        );
        this.order.groupBy = obj.groupBy;
      } catch (e) {
        Message.error(e.response.data);
        console.log(e);
      }
    },
    setCache(){
      localStorage.setItem('outPondReportGroupBy', JSON.stringify(this.groupBy))
    },
    getCache(){
      const groupBy = localStorage.getItem('outPondReportGroupBy')
      if(groupBy) this.groupBy = JSON.parse(groupBy)
    }
  },
  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.order.startDate = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      start.setMonth(0);
      this.order.startDate = this.$timeformatDay(start);
    }
    if (endTime) {
      this.order.endDate = endTime;
    } else {
      this.order.endDate = this.$timeformatDay(new Date());
    }
  },
  watch: {
    groupBy: function(val, oldVal) {
      if (val.length < 1) {
        this.$message({
          // showClose: true,
          message: "必须选中一项",
          type: "warning"
        });
        this.groupBy = oldVal;
      }
    }
  }
};
</script>
<style lang="stylus" >
.outPondReport {
  .total {
    .el-select__tags {
      top: 65%;
      height: 30px;
      overflow: auto;
    }

    .el-input__suffix {
      top: 6px;
    }

    .is-focus .el-input__suffix {
      top: 0px;
    }
  }

  .scroll-box2 {
    width: 100%;
    // max-height:550px;
    // overflow: auto;
    // overflow-x:hidden;
  }

  .table-package {
    width: 100%;
    border-collapse: collapse;
    // border 1px #ddd solid
    border: none;
  }

  .table-thead {
    border-top: 2px solid rgb(51, 137, 255);

    >tr th {
      width: 154px;
      text-align: center;
      height: 50px;
      font-size: 12px;
      line-height: 50px;
      color: #666;
      font-weight: bold;
      border: 1px solid #e0e0e0;
      border-bottom: none;
      border-bottom: 1px solid rgb(51, 137, 255);
      background-color: #f7f7f7;
    }
  }

  .table-tbodys {
    :hover {
      background: #c3e3ff;
    }

    tr {
      text-align: center;
      height: 37px;
      line-height: 37px;
      border: 1px solid #ddd;
      border: none;
      background-color: #fff;
      font-size: 12px;
    }

    td {
      width: 154px;
      border: 1px solid #e0e0e0;
      border-top: none;
      color: #666;
      vertical-align: middle;
    }
  }

  .table-tfoot {
    tr>td {
      text-align: center;
      height: 37px;
      line-height: 37px;
      color: #333;
      font-size: 12px;
    }

    .row {
      font-size: 12px;
      background-color: #fff;
      font-weight: bold;

      >td {
        width: 154px;
        text-align: center;
        border: 1px solid #e0e0e0;
        // color: #666;
        border-top: none;
        font-weight: bold;
      }
    }
  }

  .hidden {
    display: none;
  }
}

.outPondReport .table-package.fix {
  color: #666;
  position: fixed;
  z-index: 1000;
  top: 0px;
  width: calc(100% - 250px);
}
</style>
